import { render } from "./VideoSection4.vue?vue&type=template&id=3364b518&scoped=true"
import script from "./VideoSection4.vue?vue&type=script&lang=js"
export * from "./VideoSection4.vue?vue&type=script&lang=js"

import "./VideoSection4.vue?vue&type=style&index=0&id=3364b518&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3364b518"]])

export default __exports__